import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import { BASE_URL } from '@/api/api'
import { auth } from '@/api/auth'
import qs from 'qs'
import { router } from '@/router'
import apiExceptionType from '@/utils/apiExceptionType'
import { store } from '@/store/store'
import i18n from '@/lang/i18n'

axios.defaults.baseURL = BASE_URL
axios.defaults.paramsSerializer = params => qs.stringify(params, { arrayFormat: 'repeat', encode: false })
axios.defaults.headers = {
    type: 'application/json'
}

const AUTOMATIC_REQUEST_URLS = [
    'summary', 'Summary',
    '/auth/refresh', '/auth/logout', '/auth/login', '/userInformation',
    '/globalParameter', '/sampleclassifications/parameters',
    '/laboratoriesConfiguration',
    '/priorities', '/common/identifierRegexes', '/notifications/unread'
]

function resetUserDownTimeIntervalIfManualRequest(url) {
    if (store.getters.userLoggedIn && !AUTOMATIC_REQUEST_URLS.some(automaticUrl => url.includes(automaticUrl))) {
        auth.resetUserDowntimeTimeout()
    }
}

axios.interceptors.request.use((config) => {
    resetUserDownTimeIntervalIfManualRequest(config.url)

    config.headers['Accept-Language'] = i18n.locale
    if (auth.token) {
        config.headers.Authorization = `Bearer ${auth.token}`
    }
    return config
}, (err) => {
    return Promise.reject(err)
})

axios.interceptors.response.use(r => r, error => {
    if (!error.response) {
        // router.push({ name: 'login' })
        // TODO: Cuando se pierde la conexion con el servidor da un error.message === 'Network Error'. Ver que hacemos en este caso no controlado.
        return Promise.reject(error)
    }

    const status = error.response.status

    if (status === 404) {
        return Promise.reject(error)
    }

    if (status === 401) {
        if (error.response.data.code === apiExceptionType.ACCESS_DENIED) {
            router.push({ name: 'page404' })
        } else {
            auth.clearSession()
            router.push({ name: 'login' })
        }
    } else if (status === 403) {
        // TODO: handle 403
    } else if (status === 400 && error.response.data.message === 'error.validation') {
        // TODO: handle validation errors
        return 'Error'
    } else {
        // TODO: handle other errors
    }

    return Promise.reject(error)
})
Vue.use(VueAxios, axios)
